import { put } from "@redux-saga/core/effects";
import { post } from "sagas/helpers/network";
import handleNetworkError from "sagas/helpers/handleNetworkError";
import { takeLeading } from "redux-saga/effects";

function* execute(action: sage.actions.createAnimation.IFetchVideoJob) {
    yield put({
        type: "com.sage.actions.createAnimation.ISetFetchVideoJobStatus",
        status: "loading",
    } as sage.actions.createAnimation.ISetFetchVideoJobStatus);
    try {
        const response = yield post("/get-video-job", {
            video_job_id: action.videoJobId,
        });
        yield put({
            type: "com.sage.actions.createAnimation.ISetVideoJob",
            videoJob: response.data,
        } as sage.actions.createAnimation.ISetVideoJob);
        yield put({
            type: "com.sage.actions.createAnimation.ISetFetchVideoJobStatus",
            status: "none",
        } as sage.actions.createAnimation.ISetFetchVideoJobStatus);
    } catch (e) {
        yield put({
            type: "com.sage.actions.createAnimation.ISetFetchVideoJobStatus",
            status: "error",
        } as sage.actions.createAnimation.ISetFetchVideoJobStatus);
        yield handleNetworkError(e);
    }
}

export default function* saga(): Generator {
    yield takeLeading(
        "com.sage.actions.createAnimation.IFetchVideoJob",
        execute
    );
}
